// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__1Nacb","topBottomGutter":"Layout_topBottomGutter__mQq1-"};